import React, {useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Paper, Grid, Typography, useMediaQuery} from '@material-ui/core';
import {Form, CropDialog, ProductList} from './components';
import ReactCrop from 'react-image-crop';
import CropIcon from '@material-ui/icons/Crop';
import theme from 'theme';
import AddEmployeeModal from './components/Form/AddEmployeeModal';
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  rootEmpty: {
    padding: 0,
  },
  formContainer: {
    padding: theme.spacing(4),
  },
}));

const AddShipment = () => {
  const classes = useStyles();
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => setShowModal(!showModal);

  const [newData, setNewData] = useState([]);
  const [data, setData] = useState({value: ''});
  const [idSel, setIdSel] = useState('');

  function handleChangeNewData(dataNew) {
    // setNewData(newData => [...newData, dataNew]);
    setNewData([...newData, dataNew]);
  }

  function handleChangeId(id) {
    setIdSel(id);
  }

  function handleChangeData(val) {
    setData({
      value: val,
    });
  }
  return (
    <div className={isSmall ? classes.rootEmpty : classes.root}>
      {showModal ? (
        <AddEmployeeModal
          onAccept={toggleModal}
          onClose={toggleModal}
          data={data || undefined}
          handleData={handleChangeNewData}
          // reloadFunc={reloadFunction}
          // id={idSel}
          open={showModal}
        />
      ) : (
        ''
      )}

      <Grid container>
        <Grid item xs={12} sm={12}>
          <Paper className={classes.formContainer}>
            <Form
              newData={newData}
              id={idSel}
              edit={false}
              showModal={toggleModal}
              statusModal={showModal}
              handleChangeId={handleChangeId}
              handleChangeData={handleChangeData}
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddShipment;
